module.exports = __webpack_public_path__ + "img/shop_active.68cd2941.svg";